var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1024pt",
    height: "1023pt",
    viewBox: "0 0 1024 1023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 1021.066406 77.847656 C 1017.0625 70.953125 1009.714844 66.726562 1001.746094 66.726562 L 22.289062 66.726562 C 14.316406 66.726562 6.972656 70.953125 2.964844 77.847656 C -0.996094 84.742188 -0.996094 93.191406 3.007812 100.085938 L 492.738281 945.15625 C 496.703125 952.050781 504.046875 956.273438 512.015625 956.273438 C 519.984375 956.273438 527.332031 952.046875 531.292969 945.15625 L 1021.023438 100.085938 C 1024.984375 93.234375 1024.984375 84.738281 1021.066406 77.847656 Z M 1021.066406 77.847656 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.b9c17691d46ffda2230a73379e9f24b1.svg";
export { ForwardRef as ReactComponent };